/**
 * Created by Smile on 2017/9/2.
 */
import * as $ajax from '../router/http'
import * as Util from 'util'
import JSEncrypt from 'jsencrypt'

// api版本
const prefix = Util.getApiVersion()

/**
 * 登陆
 */
export function signin (params) {
  let url = prefix + '/user/login'
  return new Promise((resolve, reject) => {
    $ajax.ajaxGet(encodeURI('/v2/system/get_publickey?account_id=-1&uid=-1&S=undefined')).then((res) => {
      let encryptor = new JSEncrypt()
      encryptor.setPublicKey(res.public_key)  // 设置公钥
      let password = encryptor.encrypt(params.password)  // 对密码进行加密
      let postData = {
        user_slug: params.user_slug,
        password,
        bind_type: params.bind_type,
        timesid: params.timesid
      }
      resolve($ajax.ajaxPost(encodeURI(url), postData))
    }).catch(error => {
      reject(error)
    })
  })
}
/**
 * 获取AD域
 */
export function getDomains (params) {
  let url = prefix + '/ad/get_domains?isPhoneLogin=1'
  return $ajax.ajaxGet(encodeURI(url))
}

/**
 * 获取用户信息
 */
export function getInfo (params) {
  let url = prefix + '/user/info/get?account_id=1&uid=' + Util.getUserId()
  if (params.user_id) {
    url += params.user_id
  }
  return $ajax.ajaxGet(encodeURI(url))
}
/**
 * 获取用户信息By Cookie
 */
export function getInfoByCookie (params) {
  let url = prefix + '/user/info/get?X-LENOVO-SESS-ID=' + params.token
  return $ajax.ajaxGet(encodeURI(url))
}

/**
 * 获取客户端下载地址
 */
export function mobileDownload (postData) {
  let url = prefix + '/config/mobileDownloadUrl'
  return $ajax.ajaxPost(encodeURI(url), postData)
}
/**
 * 用户退出登录
 @param {object} params
 @param {function} params.callback 回调函数
 */
export function signout (params) {
  var url = prefix + '/user/logout'
  var postData = {}
  return $ajax.ajaxPost(encodeURI(url), postData)
}
/**
 * 设置自定义配置
 @param {object} params
 @param {function} params.callback 回调函数
 */
export function configSet (params) {
  var url = prefix + '/config/set'
  var postData = {
    config_type: params.config_type,
    config_id: params.config_id,
    name: params.name,
    value: params.value
  }
  var json = {'json': '[' + JSON.stringify(postData) + ']'}
  return $ajax.ajaxPost(encodeURI(url), json)
}
/**
 * 获取自定义配置
 @param {object} params
 @param {function} params.callback 回调函数
 */
export function configGet (params) {
  var url = prefix + '/config/get?config_type=' + params.config_type + '&name=' + params.name
  if (params.config_id !== '') {
    url += '&config_id=' + params.config_id
  }
  return $ajax.ajaxGet(encodeURI(url))
}
// 三方登录接口
export function authlogin (params) {
  var url = prefix + '/authlogin/get?name=' + params.name + '&terminal=' + params.terminal
  return $ajax.ajaxGet(encodeURI(url))
}
// 发送验证码
export function getCode (postData) {
  var url = prefix + '/user/captche_send?account_id=-1&uid=-1&S=undefined'
  return $ajax.ajaxPost(encodeURI(url), postData)
}
// 校验验证码
export function verifyCode (postData) {
  var url = prefix + '/user/captche_verify?account_id=-1&uid=-1&S=undefined'
  return $ajax.ajaxPost(encodeURI(url), postData)
}



// WEBPACK FOOTER //
// ./src/SDK/UserManager.js